exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-legend {\n  background-color: white;\n  border: 3px solid #dddddd; }\n  .color-legend.color-legend-fixed {\n    position: fixed;\n    left: 15px;\n    bottom: 15px;\n    z-index: 1005; }\n    @media print {\n      .color-legend.color-legend-fixed {\n        display: none; } }\n  @media screen {\n    .color-legend.print-only {\n      display: none; } }\n\n.color-legend-block {\n  width: 40px;\n  height: 40px;\n  display: inline-block; }\n\n.color-legend-row {\n  display: flex;\n  align-items: center;\n  margin: 0.75rem; }\n", ""]);

// exports
